import { render, staticRenderFns } from "./customer-contracts-list.vue?vue&type=template&id=34af1668&scoped=true"
import script from "./customer-contracts-list.vue?vue&type=script&lang=js"
export * from "./customer-contracts-list.vue?vue&type=script&lang=js"
import style0 from "./customer-contracts-list.vue?vue&type=style&index=0&id=34af1668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34af1668",
  null
  
)

export default component.exports